module.exports = "<div class=\"wrap\">\r\n    <div class=\"tips\">\r\n        <img class=\"pic\" src=\"/assets/img/404.png\" alt=\"\">\r\n        <p>{{'home.notfound.not-found-page' | translate}}</p>\r\n        <p>{{'home.notfound.redirect-after-seconds' | translate:param}}</p>\r\n        <div class=\"jump-btn\" (click)=\"jump2Index()\">{{'home.notfound.redirect-imediately' | translate}}</div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/notFound/notFound.component.html
// module id = ../../../../../src/app/home/components/notFound/notFound.component.html
// module chunks = main